<!--
 * @Author: 夏元元 xiayuanyuan@itcast.cn
 * @Date: 2025-01-16 16:29:12
 * @LastEditors: 夏元元 xiayuanyuan@itcast.cn
 * @LastEditTime: 2025-01-17 17:54:24
 * @FilePath: \subject-topic-new\components\coursePage\design\Box9.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="box9">
    <pageTitle
      title="IT项目辅导 轻松学做毕设"
      titleColor="#313433"
      titColor="#313433"
    /> 
    <div class="content">
      <div class="list-box">
        <div class="list-tag"></div>
        <div class="line-one"></div>
        <div class="line-two"></div>
        <div class="list-item" v-for="(item, index) in docList" :key="index">
          <img :src="item.icon" />
          <p class="title">{{item.title}}</p>
          <div class="text"><p>{{item.textTop}}</p><p>{{item.textBottom}}</p></div>
          <a v-if="item.url.endsWith('.pdf')" @click="openPdf(item)">{{item.aName}}</a>
          <a v-else-if="item.url.endsWith('.mp4')" @click="openVideo(item)">{{item.aName}}</a>
          <a v-else @click="openDialog(item)">{{item.aName}}</a>
        </div>
      </div>
      <div class="list-box">
        <div class="list-tag"></div>
        <div class="line-one"></div>
        <div class="line-two"></div>
        <div class="list-item" v-for="(item, index) in twoDocList" :key="index">
          <img :src="item.icon" />
          <p class="title">{{item.title}}</p>
          <div class="text"><p>{{item.textTop}}</p><p>{{item.textBottom}}</p></div>
          <a v-if="item.url.endsWith('.pdf')" @click="openPdf(item)">{{item.aName}}</a>
          <a v-else-if="item.url.endsWith('.mp4')" @click="openVideo(item)">{{item.aName}}</a>
          <a v-else @click="openDialog(item)">{{item.aName}}</a>
        </div>
      </div>
      <div class="serve-box">
        <div class="serve-title"></div>
      </div>
    </div>
    <CourseVideo :src="videoSrc" :flag="videoFlag" @close="close" specialStyle="2" autoplay="true"></CourseVideo>
    <van-popup
      v-model="showPopup"
      position="bottom"
      closeable
      round
      :style="{  overflowY: 'hidden', height: '90%' }"
      @close="onClose"
    >
      <div class="popup-title">设计文档</div>
      <div class="iframe-box">
        <!-- <iframe :src="pdfFile" width="100%" height="100%"></iframe> -->
        <vue-office-pdf v-if="pdfFile" :src="pdfFile" />
      </div>
    </van-popup>
    <van-popup
      v-model="flag"
      position="bottom"
      closeable
      round
      :style="{  overflowY: 'hidden', height: 'auto' }"
      @close="closeDialog"
    >
      <div class="popup-title">代码包</div>
      <img class="code-img" :src="src" />
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import CourseVideo from "../common/courseVideo.vue";
import VueOfficePdf from '@vue-office/pdf';
export default {
  components: {
    pageTitle,
    CourseVideo,
    VueOfficePdf
  },
  data() {
    return {
      docList: [{
        icon: require('../../../assets/coursePage/design/box9/icon1.png'),
        title: '讲代码',
        textTop: '讲解代码逻辑',
        textBottom: '学会开发方法',
        aName: '讲解示例',
        url: 'https://file.boxuegu.com/bxgyingxiao/%E8%AE%B2%E4%BB%A3%E7%A0%81.mp4'
      },{
        icon: require('../../../assets/coursePage/design/box9/icon2.png'),
        title: '教安装',
        textTop: '指导本地部署',
        textBottom: '学习更方便',
        aName: '教程示例',
        url: 'https://file.boxuegu.com/bxgyingxiao/%E6%95%99%E5%AE%89%E8%A3%85.mp4'
      },{
        icon: require('../../../assets/coursePage/design/box9/icon3.png'),
        title: '创新指导',
        textTop: '打造不同界面',
        textBottom: '应用多元场景',
        aName: '应用指导示例',
        url: 'https://file.boxuegu.com/bxgyingxiao/%E5%88%9B%E6%96%B0%E6%8C%87%E5%AF%BC.mp4'
      },{
        icon: require('../../../assets/coursePage/design/box9/icon4.png'),
        title: '代码包',
        textTop: '含代码、环境安装包',
        textBottom: '下载即可运行',
        aName: '代码示例',
        url: require('../../../assets/coursePage/design/box9/codeBox.png')
      }],
      twoDocList: [{
        icon: require('../../../assets/coursePage/design/box9/icon5.png'),
        title: '设计文档',
        textTop: '拆解项目方案',
        textBottom: '学会设计思路',
        aName: '文档示例',
        url: 'https://file.boxuegu.com/bxgyingxiao/%E8%BD%AF%E4%BB%B6%E8%AE%BE%E8%AE%A1%E6%96%87%E6%A1%A3.pdf'
      },{
        icon: require('../../../assets/coursePage/design/box9/icon6.png'),
        title: '开题参考',
        textTop: '学习模板化方法',
        textBottom: '写出自己的开题',
        aName: '报告示例',
        url: 'https://file.boxuegu.com/bxgyingxiao/%E5%BC%80%E9%A2%98%E6%8A%A5%E5%91%8A%E6%A8%A1%E6%9D%BF.pdf'
      },{
        icon: require('../../../assets/coursePage/design/box9/icon7.png'),
        title: '论文辅导',
        textTop: '培养写作能力',
        textBottom: '基于设计文档写论文',
        aName: '辅导示例',
        url: 'https://file.boxuegu.com/bxgyingxiao/%E8%AE%BA%E6%96%87%E8%BE%85%E5%AF%BC.mp4'
      },{
        icon: require('../../../assets/coursePage/design/box9/icon8.png'),
        title: '功能演示',
        textTop: '展示项目功能',
        textBottom: '所见即所得',
        aName: '演示示例',
        url: 'https://file.boxuegu.com/bxgyingxiao/%E5%8A%9F%E8%83%BD%E6%BC%94%E7%A4%BA.mp4'
      }],
      videoSrc: '',
      videoFlag: false,
      pdfFile: '',
      src: '',
      flag: false,
      showPopup: false
    };
  },
  methods: {
    openVideo(item) {
        this.videoSrc = item.url
        this.videoFlag = true
    },
    close() {
        this.videoSrc = ''
        this.videoFlag = false
    },
    openPdf(item) {
        this.pdfFile = item.url
        this.showPopup = true
    },
    openDialog(item) {
        this.src = item.url
        this.flag = true
    },
    closeDialog() {
        this.flag = false
    },
    onClose() {
      this.showPopup = false
      this.pdfFile = ''
    }
  },
};
</script>

<style lang="less" scoped>
.box9 {
  padding: 80px 0 76px;
  width: 100%;
  background: #F6FBFE;
  .content{
    margin: 54px 0 0;
    .list-box {
        margin: 0 32px 48px;
        position: relative;
        box-sizing: border-box;
        width: 686px;
        height: 922px;
        background: #FFFFFF;
        box-shadow: 0px 10px 8px 0px #EDF4F9;
        border-radius: 16px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .list-tag {
          position: absolute;
          left: -12px;
          top: 8px;
          width: 184px;
          height: 72px;
          background: url('../../../assets/coursePage/design/box9/tag1.png') no-repeat;
          background-size: cover;
        }
        .line-one {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
          width: 604px;
          height: 2px;
          background: #EAF4F9;
          border-radius: 5px;
        }
        .line-two {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          margin: auto;
          width: 2px;
          height: 760px;
          background: #EAF4F9;
          border-radius: 5px;
        }
        .list-item {
            width: 50%;
            padding: 16px 0;
            text-align: center;
            img {
              margin-top: 64px;
              width: 100px;
              height: 108px;
            }
            .title {
              margin-top: 4px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 32px;
              color: #24375C;
              line-height: 48px;
              text-align: center;
              font-style: normal;
            }
            .text {
              margin-top: 8px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 28px;
              color: #707E9B;
              line-height: 44px;
              text-align: center;
              font-style: normal;
            }
            a {
              display: block;
              margin-top: 16px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 28px;
              color: #165DFF;
              line-height: 44px;
              text-align: center;
              font-style: normal;
              text-decoration-line: underline;
            }
        }
    }
    .list-box:nth-child(2) {
      .list-tag {
        background: url('../../../assets/coursePage/design/box9/tag2.png') no-repeat;
        background-size: cover;
      }
    }
    .serve-box {
      position: relative;
        margin: 0 auto;
        background: url('../../../assets/coursePage/design/box9/serve-bg.png') no-repeat;
        width: 702px;
        height: 502px;
        background-size: cover;
        .serve-title {
          position: absolute;
          left: -4px;
          top: 8px;
          width: 184px;
          height: 72px;
          background: url('../../../assets/coursePage/design/box9/tag3.png') no-repeat;
          background-size: cover;
        }
    }
  }
  .popup-title {
    margin: 48px 0 40px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 36px;
    color: #1D2129;
    line-height: 52px;
    text-align: center;
    font-style: normal;
  }
  .iframe-box {
    height: calc(100% - 140px);
    /deep/ .vue-office-pdf {
      height: 100%;
      -webkit-overflow-scrolling: touch;
    }
    /deep/ .vue-office-pdf-wrapper {
      background: #efefef !important;
      padding: 20px 0 !important;
    }
  }
  .code-img {
    display: block;
    margin: 32px auto 48px;
    width: 702px;
    height: 772px;
  }
}
</style>
